import RBush from 'rbush';

import { IRBushItem } from '../../../../../types/map';
import { makeContextModule } from '../../../../../utils/makeContextModule';

export interface IFeaturesContext {
  rbush: RBush<IRBushItem>;
  pointsLayer: YMaps.PointsLayer;
  hotspotsLayer: YMaps.HotspotsLayer;
  balloonManager: YMaps.BalloonManager;
  popupManager: YMaps.PopupManager;
}

export const {
  Context: FeaturesContext,
  useContext: useFeaturesContext,
  withContext: withFeaturesContext,
} = makeContextModule<IFeaturesContext>({
  contextName: 'FeaturesContext',
});
